import { useParams, useSearchParams } from 'react-router-dom';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { useMutation } from 'react-query';
import { STORAGE_KEYS } from '../config';
import Logo from '../components/logo';
import success from '../success.png';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../utils/firebase';


import 'react-phone-number-input/style.css';
import { PatternFormat } from 'react-number-format';

const ENABLE_MOCK_DATA = false;

function Spinner() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="h-12 w-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
}

function AddClient() {
  const { spId } = useParams();
  const [searchParams] = useSearchParams();
  const [showError, setShowError] = useState(false);
  const [showNumberError, setShowNumberError] = useState(false);
  const [formData, setFormData] = useState({
    name: ENABLE_MOCK_DATA ? 'Damon' : '',
    lastName: ENABLE_MOCK_DATA ? 'Dragotis' : '',
    phoneNumber: ENABLE_MOCK_DATA ? '6125323745' : '',
    formattedPhoneNumber: ENABLE_MOCK_DATA ? '+16125323745' : '',
    allowSms: true,
  });

  const companyId = searchParams.get('companyId');
  const spSpeciality = searchParams.get('spSpeciality');
  const spName = searchParams.get('spName');
  const originatorPhoneNumber = searchParams.get('originatorPhoneNumber');

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const inputStyle =
    'mb-5 block w-full p-4 text-sm text-gray-900 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500';
  const inputErrorStyle = showError && 'border-red-300';
  const inputNumberErrorStyle = showNumberError && 'border-red-300';


  const { mutate: addClient } = useMutation(
    async () => {

      const addClient = httpsCallable(functions, 'addClient');

      const data = {
        spId,
        spName,
        spSpeciality,
        companyId,
        // originatorPhoneNumber,
        clientName: `${formData.name} ${formData.lastName}`,
        clientPhoneNumber: formData.formattedPhoneNumber.replaceAll(' ', '').replace('(', '').replace(')', '').replace('-', ''),
      };
      const result = await addClient(data);
    },
    {
      onSuccess: (newClientKey) => {
        setShowSuccessMessage(true);
        setIsSubmitting(false)
      },
      onError: () => {
        setIsSubmitting(false)
      }
    }
  );

  const handleSaveClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.preventDefault();
    if (formData.name === '' && formData.phoneNumber === '') {
      return setShowError(true);
    }

    setShowNumberError(false);
    setShowError(false);
    saveUserInfo();
    setIsSubmitting(true);
    
    addClient();
  };

  const saveUserInfo = () => {
    // store in localStroage so it persist to other location
    window.localStorage.setItem(STORAGE_KEYS.USER_NAME, `${formData.name} ${formData.lastName}`);
    window.localStorage.setItem(STORAGE_KEYS.USER_PHONE, formData.phoneNumber);
  };

  const handleInputChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((data) => ({
      ...data,
      [target.name]: target.name === 'allowSms' ? !formData.allowSms : target.value,
    }));
  };

  console.log('[render]', {formData,companyId, spId, spSpeciality, spName, originatorPhoneNumber })

  return (
    <div className='flex justify-center flex-col items-center py-[80px] px-12'>
      <Logo companyId={companyId!}></Logo>

      <form className='flex flex-col items-center w-full' autoComplete='on'>
        {showSuccessMessage ? (
          <>
            <img src={success} alt='Success' />
            <div>
              <p className='text-center text-3xl font-semibold mb-4'>
                You're all set! 
              </p>
              <p className='text-center text-lg font-semibold mb-6'>You've been added to 
              {' '}{spName}'s CheckN</p>
              <p className='text-center text-base mx-6'>We just sent you a text, save that number to your contacts and text {spName} whenever you want.</p>
            </div>
          </>
        ) : (
          <div className='flex flex-col gap-10 relative'>
            <div>
              <p className='text-center text-3xl font-bold mb-4'>
                You're a VIP
              </p>
              <p className='text-center text-lg font-semibold'>{spName} wants to add you to their CheckN so you can text them whenever you need a service.</p>
            </div>
            
            
            <p className='text-center text-base justify-center'>Enter your name and phone number.</p>
            <div>
            {isSubmitting && <div className="absolute inset-0 flex items-center justify-center bg-white opacity-70">
              <Spinner />
            </div>}
              
              <input
                required
                name='name'
                type='text'
                onChange={handleInputChange}
                value={formData.name}
                className={twMerge(inputStyle, inputErrorStyle)}
                placeholder='Name'
                autoComplete="given-name"
              />
              <input
                required
                type='text'
                name='lastName'
                onChange={handleInputChange}
                value={formData.lastName}
                className={twMerge(inputStyle, inputErrorStyle)}
                placeholder='Last Name'
                autoComplete="family-name"
              />
              <PatternFormat
                required
                type='tel'
                name='phoneNumber'
                autoComplete='tel'
                className={twMerge(inputStyle, inputErrorStyle, inputNumberErrorStyle)}
                format='+1 (###) ###-####'
                value={formData.phoneNumber}
                valueIsNumericString={true}
                placeholder='Enter phone number'
                onValueChange={({ value, formattedValue }) => {
                  console.log()
                  setFormData((data) => ({
                    ...data,
                    phoneNumber: value,
                    formattedPhoneNumber: formattedValue
                  }));
                }}
              />
              {showError === true && (
                <div className='text-red-700 text-center text-2xl p-2.5'>
                  Please enter name & phone number
                </div>
              )}
              
            </div>

            <button
                className='bg-blue-700 w-full block text-white text-base p-2 px-6 rounded-full'
                onClick={handleSaveClick}
                disabled={isSubmitting}
              >
                Next
              </button>
          </div>
        )}
      </form>
    </div>
  );
}

export default AddClient;
